"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeWithDefaultColor = exports.getScopedVariables = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("./constants");
const getScopedVariables = _ref => {
  let {
    theme,
    scopeId
  } = _ref;
  const scopedSelector = "[".concat(_constants.THEME_SCOPE_ID, "='").concat(scopeId, "']");
  const scopedDarkModeDescendantSelector = "".concat(_utils.PREFERS_COLOR_SCHEME_DARK_SELECTOR, " ").concat(scopedSelector);
  //compound selector is needed for inverted theme components. (showing dark theme colors when application is in light theme)
  const scopedDarkModeCompoundSelector = "".concat(_utils.PREFERS_COLOR_SCHEME_DARK_SELECTOR).concat(scopedSelector);
  return {
    [scopedSelector]: theme[_constants.THEME_ROOT_SELECTOR],
    ["".concat(scopedDarkModeDescendantSelector, ", ").concat(scopedDarkModeCompoundSelector)]: theme[_utils.PREFERS_COLOR_SCHEME_DARK_SELECTOR]
  };
};
exports.getScopedVariables = getScopedVariables;
const primaryTextColorToken = (0, _utils.token)('color.text.primary');
const getThemeWithDefaultColor = theme => ({
  ...theme,
  [_constants.THEME_ROOT_SELECTOR]: {
    ...theme[_constants.THEME_ROOT_SELECTOR],
    color: primaryTextColorToken
  }
});
exports.getThemeWithDefaultColor = getThemeWithDefaultColor;